import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'
import { actions } from '..'
import { Actions, StoreState } from '../types'

export interface UserInfo {
    oid: string
    upn: string
    name: string
    tenantId?: string
}

type State = UserInfo | null

function login(state: State = null, action: Actions): State {
    switch (action.type) {
        case getType(actions.login):
            return action.payload
    }
    return state
}

function logout(state: State = null, action: Actions): State {
    switch (action.type) {
        case getType(actions.logout):
            return null
    }
    return state
}

export default combineReducers({
    login,
    logout
})


function getRoot(state: StoreState) { return state.login }

export function selectUser(state: StoreState) {
    return getRoot(state).login
}
